import { Injectable } from '@angular/core'
import { MessageService } from 'primeng/api'
import { environment } from 'src/config/environments/environment'

const SERVER_URL = environment.serverUrl
@Injectable({
  providedIn: 'root',
})
export class ImageUploaderService {
  constructor(private messageService: MessageService) {}
  upload(file: File, uploadCategory: string | null = null) {
    const controller = new AbortController()
    const formdata = new FormData()
    formdata.append('file', file, file.name)
    if (uploadCategory) {
      formdata.append('uploadCategory', uploadCategory)
    }

    const requestOptions = {
      method: 'POST',
      body: formdata,
      signal: controller.signal,
    }

    return {
      abort: () => controller.abort(),
      response: fetch(SERVER_URL + '/file/upload', requestOptions)
        .then((response) => response.json() as Promise<unknown>)
        .catch((error: unknown) => {
          this.messageService.add({ severity: 'error', summary: 'File Upload Error', detail: (error as Error).message, life: 10000 })
        }),
    }
  }
}
